import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { DialogTitle as DialogTitle$1 } from "@mui/material";
import { X } from "react-feather";
import { dialogTitleStyles, iconButtonStyles, iconStyles } from "./DialogTitle.styles.js";
import { IconButton } from "../IconButton/IconButton.js";
const DialogTitle = ({
  children,
  onClose,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    DialogTitle$1,
    {
      variant: "inherit",
      fontWeight: "bold",
      css: dialogTitleStyles,
      ...props,
      children: /* @__PURE__ */ jsxs("div", { className: "Ascend-DialogTitle-Container", children: [
        /* @__PURE__ */ jsx("div", { className: "Ascend-DialogTitle-Content", children }),
        onClose && /* @__PURE__ */ jsx(IconButton, { css: iconButtonStyles, onClick: onClose, "aria-label": "close", children: /* @__PURE__ */ jsx(X, { css: iconStyles }) })
      ] })
    }
  );
};
export {
  DialogTitle
};
//# sourceMappingURL=DialogTitle.js.map
